import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { AuthShow } from "@/components/auth/AuthShow";
import { LocalAuthProvider } from "@/components/auth/LocalAuth";
import { HelpAssistant } from "@/components/HelpAssistant";
import Landing from "@/pages/Landing";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PanelLayout from "@/pages/panel/PanelLayout";
import Dashboard from "@/pages/panel/Dashboard";
import Orders from "@/pages/panel/Orders";
import Tables from "@/pages/panel/Tables";
import MenuPage from "@/pages/panel/MenuPage";
import Kasa from "@/pages/panel/Kasa";
import Couriers from "@/pages/panel/Couriers";
import Integrations from "@/pages/panel/Integrations";
import Printer from "@/pages/panel/Printer";
import CallerHub from "@/pages/panel/CallerHub";
import Support from "@/pages/panel/Support";
import Account from "@/pages/panel/Account";
import Admin from "@/pages/panel/Admin";
import QrMenu from "@/pages/QrMenu";
import CourierApp from "@/pages/CourierApp";
import CallerApp from "@/pages/CallerApp";

function Protected({ children }) {
  return (
    <>
      <AuthShow when="signed-in">{children}</AuthShow>
      <AuthShow when="signed-out"><Navigate to="/sign-in" replace /></AuthShow>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <LocalAuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/menu/:slug" element={<QrMenu />} />
          <Route path="/kurye" element={<CourierApp />} />
          <Route path="/caller" element={<CallerApp />} />
          <Route path="/panel" element={<Protected><PanelLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="siparisler" element={<Orders />} />
            <Route path="masalar" element={<Tables />} />
            <Route path="menu" element={<MenuPage />} />
            <Route path="kasa" element={<Kasa />} />
            <Route path="kuryeler" element={<Couriers />} />
            <Route path="entegrasyonlar" element={<Integrations />} />
            <Route path="yazici" element={<Printer />} />
            <Route path="caller-id" element={<CallerHub />} />
            <Route path="destek" element={<Support />} />
            <Route path="hesap/*" element={<Account />} />
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
        <HelpAssistant />
        </LocalAuthProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
